import { BASE_URL } from './config';

export const getProfile = async token => {
  try {
    const res = await fetch(`${BASE_URL}profile`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
      },
    });

    if (res.status === 304) {
      console.log('Profile data not modified (304)');
      return { success: true, data: null, notModified: true };
    }

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();
    return { success: true, data };
  } catch (error) {
    console.error('Get Profile API Error:', error);
    return { success: false, error: error.message };
  }
};

export const updateProfile = async (profileData, token) => {
  try {
    const res = await fetch(`${BASE_URL}profile`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(profileData),
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();
    return { success: true, data };
  } catch (error) {
    console.error('Update Profile API Error:', error);
    return { success: false, error: error.message };
  }
};

export const getPurchaseHistory = async (token, { from, to } = {}) => {
  try {
    const params = new URLSearchParams();
    if (from) params.append('from', from);
    if (to) params.append('to', to);

    const url = `${BASE_URL}stamps/transactions/purchase${
      params.toString() ? '?' + params.toString() : ''
    }`;

    const res = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
      },
    });

    if (res.status === 304) {
      return { success: true, data: null, notModified: true };
    }

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();
    return { success: true, data };
  } catch (error) {
    console.error('Get Profile API Error:', error);
    return { success: false, error: error.message };
  }
};

export const getSpendingHistory = async (token, { from, to } = {}) => {
  try {
    const params = new URLSearchParams();
    if (from) params.append('from', from);
    if (to) params.append('to', to);

    const url = `${BASE_URL}stamps/transactions/spend${
      params.toString() ? '?' + params.toString() : ''
    }`;

    const res = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
      },
    });

    if (res.status === 304) {
      console.log('Profile data not modified (304)');
      return { success: true, data: null, notModified: true };
    }

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();
    return { success: true, data };
  } catch (error) {
    console.error('Get Profile API Error:', error);
    return { success: false, error: error.message };
  }
};

export const getDocumentList = async (params = {}, token) => {
  try {
    const queryString = Object.keys(params)
      .filter(
        key =>
          params[key] !== undefined &&
          params[key] !== null &&
          params[key] !== ''
      )
      .map(
        key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`
      )
      .join('&');
    const url = `${BASE_URL}documents${queryString ? `?${queryString}` : ''}`;

    const res = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
      },
    });

    if (res.status === 304) {
      console.log('Document list not modified (304)');
      return { success: true, data: null, notModified: true };
    }

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();
    return { success: true, data };
  } catch (error) {
    console.error('Get Document List API Error:', error);
    return { success: false, error: error.message };
  }
};

export const getStampedFile = async (token, documentId) => {
  try {
    const res = await fetch(`${BASE_URL}documents/${documentId}/file`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const fileBlob = await res.blob();
    return fileBlob;
  } catch (error) {
    console.error('Get Stamped File By ID API Error:', error);
    throw error;
  }
};

export const getAccountBalance = async token => {
  try {
    const res = await fetch(`${BASE_URL}getCounts/profile`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
      },
    });

    if (res.status === 304) {
      console.log('Account balance not modified (304)');
      return { success: true, data: null, notModified: true };
    }

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();
    return { success: true, data };
  } catch (error) {
    console.error('Get Account Balance API Error:', error);
    return { success: false, error: error.message };
  }
};

export const getNotifications = async (token, notif) => {
  try {
    let url = `${BASE_URL}notifications`;
    if (notif && typeof notif === 'object') {
      const params = new URLSearchParams();
      Object.entries(notif).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          params.append(key, value);
        }
      });
      if (params.toString()) {
        url += `?${params.toString()}`;
      }
    }
    const res = await fetch(url, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
      },
    });

    if (res.status === 304) {
      console.log('Notifications not modified (304)');
      return { success: true, data: null, notModified: true };
    }

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();
    return { success: true, data };
  } catch (error) {
    console.error('Get Notifications API Error:', error);
    return { success: false, error: error.message };
  }
};

export const markAllNotificationsAsRead = async token => {
  try {
    const res = await fetch(`${BASE_URL}notifications/read-all`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();
    return { success: true, data };
  } catch (error) {
    console.error('Mark All Notifications As Read API Error:', error);
    return { success: false, error: error.message };
  }
};

export const getBundleList = async token => {
  try {
    const res = await fetch(`${BASE_URL}stamps/bundles`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
      },
    });

    if (res.status === 304) {
      console.log('Bundle list not modified (304)');
      return { success: true, data: null, notModified: true };
    }

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();
    return { success: true, data };
  } catch (error) {
    console.error('Get Bundle List API Error:', error);
    return { success: false, error: error.message };
  }
};

export const getVoucherList = async token => {
  try {
    const res = await fetch(`${BASE_URL}stamps/vouchers`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
        'Cache-Control': 'no-cache',
        Pragma: 'no-cache',
        Expires: '0',
      },
    });

    if (res.status === 304) {
      console.log('Voucher list not modified (304)');
      return { success: true, data: null, notModified: true };
    }

    if (!res.ok) {
      throw new Error(`HTTP error! status: ${res.status}`);
    }

    const data = await res.json();
    return { success: true, data };
  } catch (error) {
    console.error('Get Voucher List API Error:', error);
    return { success: false, error: error.message };
  }
};
